<template>
  <div :class="classes">
    <h6 v-if="label" class="bx-value-label" v-html="label"></h6>
    <div :class="contentClasses">
      <img v-if="icon" :src="icon" class="icon" />
      <bx-progress-circular v-if="progress" :value="value" />
      <span :class="classesValues">
        {{ value }}
        <b>{{ suffix }}</b>
      </span>
      <span v-if="units" class="bx-value-units">{{ units }}</span>
    </div>
  </div>
</template>
<script>
import BxProgressCircular from "./BxProgressCircular";
export default {
  name: "bx-value",
  components: { BxProgressCircular },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    suffix: {
      type: String,
      default: ""
    },
    label: {
      type: [String, Number],
      default: null
    },
    fontSize: {
      type: String,
      default: "lg"
    },
    units: {
      type: String,
      default: null
    },
    valueColor: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    progress: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    }
  },
  computed: {
    classes() {
      const classes = ["bx-value"];
      if (this.color) {
        classes.push(`bx-color-${this.color}`);
      }

      if (this.label) {
        classes.push(`with-label`);
      }

      if (this.dark) {
        classes.push(`bx-dark`);
      }

      return classes;
    },
    classesValues() {
      const classes = ["bx-value-value"];
      if (this.valueColor) {
        classes.push(`bx-value-${this.valueColor}`);
      }

      return classes;
    },
    contentClasses() {
      const classes = ["bx-value-content"];
      if (this.fontSize !== "lg") {
        classes.push(`bx-font-size-${this.fontSize}`);
      }
      return classes;
    }
  }
};
</script>
